import { render, staticRenderFns } from "./ObjectSelection.vue?vue&type=template&id=07d09671&scoped=true&"
import script from "./ObjectSelection.vue?vue&type=script&lang=js&"
export * from "./ObjectSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d09671",
  null
  
)

export default component.exports